const convertDollarsToCents = dollars => {
  return dollars * 100;
};

export const transform = tripTypeData => {
  return {
    ...tripTypeData,
    costPerKM: Math.floor(convertDollarsToCents(tripTypeData.costPerKM)),
    flagFall: Math.floor(convertDollarsToCents(tripTypeData.flagFall)),
    costPerMin: Math.floor(convertDollarsToCents(tripTypeData.costPerMin)),
  };
};
